<ng-container *ngIf="dataService.connectionLinkType !== null">
<div id="paymentComplete" class="header container kompakt">
    <ng-container *ngIf="!dataService.isKompakt()">
      <h1 *ngIf="_contractorName" class="text-center fw-bold text-uppercase mb-0">{{ _contractorName }}</h1>
      <img src="assets/banner/PrivatemedNext-banner-640-kep.png" class="kompakt-img">
    </ng-container>
    <ng-container *ngIf="dataService.isKompakt()">
      <img src="assets/banner/Kompakt-banner-640-kep.png" class="kompakt-img">
    </ng-container>

    <div class="row pt-5 details-row" *ngIf="this.paymentProcessEnded">
        <div class="col-12">
            <div class="icons mb-3">
                <fa-icon class="faCreditCard" [icon]="faCreditCard"></fa-icon>
                <fa-icon *ngIf="this.paymentSuccessful" class="faCheckCircle response-indicator" [icon]="faCheckCircle"></fa-icon>
                <fa-icon *ngIf="!this.paymentSuccessful" class="faTimesCircle response-indicator" [icon]="faTimesCircle"></fa-icon>
            </div>

            <h1 class="text-center m-0" *ngIf="this.paymentSuccessful">{{ 'paymentComplete.paymentOK' | translate }}</h1>
            <h1 class="text-center m-0" *ngIf="!this.paymentSuccessful">{{ 'paymentComplete.paymentNotOK' | translate }}</h1>

            <p class="text-center fw-bold mt-2" *ngIf="this.paymentSuccessful">{{ 'paymentComplete.feedback' | translate }}</p>

            <div class="details mt-4">
                <span class="fw-bold me-2">{{ 'paymentComplete.contractGroupName' | translate }}:</span>
                <span class="mb-0"> {{this.insuredPerson.contractGroupName}}</span>
                <span *ngIf="this.insuredPerson.contractGroupSubName"> - {{this.insuredPerson.contractGroupSubName}}</span>
                <br>
                <span class="fw-bold me-2">{{ 'paymentComplete.paymentTransactionCode' | translate }}:</span>
                <span> {{this.insuredPerson.paymentTransactionCode}}</span>
                <br>
                <span class="fw-bold me-2">{{ 'paymentComplete.offerNumber' | translate }}:</span>
                <span> {{this.insuredPerson.offerNumber}}</span>
                <br>
                <span class="fw-bold me-2">{{ 'paymentComplete.frequencyFee' | translate }}:</span>
                <span> {{this.formatCurrency(this.insuredPerson.frequencyFee)}} Ft</span>

                <button *ngIf="!this.paymentSuccessful" type="button" class="btn pay-button mt-5 mx-auto" (click)="restartPayment()">{{ 'paymentComplete.tryAgain' | translate }}</button>
            </div>
        </div>
    </div>
</div>
</ng-container>
